import { FILTER_BY, LOADED } from "./actionTypes"

export const loadFilteredPost = (posts = []) => {
    return { type: LOADED, payload: posts }
}
export const filterBy = (type, value) => {
    return { type: FILTER_BY, payload: { type, value } }
}